export default function PasswordPolicy() {
  return (
    <ul className='text-sm list-disc list-inside dark:text-zinc-400'>
      <li>Password minium length is 8 character(s)</li>
      <li>Contains at least 1 number</li>
      <li>Contains at least 1 special character</li>
      <li>Contains at least 1 uppercase letter</li>
      <li>Contains at least 1 lowercase letter</li>
    </ul>
  )
}
